<template>
  <AbstractPop>
    <template v-slot>
      <div class="dialog type-small">
        <header class="dialog-header">
          <h2 class="dialog-title">담기</h2>
          <button
            type="button"
            class="dialog-close"
            data-popup-close
            @click="() => emits('close')"
          >
            <span class="c-icon icon-large-x"></span>
            <span class="sr-only">팝업 닫기</span>
          </button>
        </header>

        <div class="dialog-content">
          <div class="dialog-content-inner">
            <div class="select-row">
              <div class="select-wrapper">
                <select
                  class="category-select drop-btn"
                  id="categorySelect"
                  v-model="data.groupSn"
                >
                  <option value="">선택</option>
                  <option
                    v-for="item in data.groutList"
                    :key="item.groupSn"
                    :value="item.groupSn"
                  >
                    {{ item.groupName }}
                  </option>
                </select>
              </div>
              <button
                type="button"
                class="my-add-btn"
                id="addBtn"
                @click="btnSelectGroup()"
              >
                추가
              </button>
            </div>
          </div>
        </div>
 
        <div class="dialog-footer">
         <!-- <button type="button" class="close-btn" @click="() => emits('close')">
            × 창닫기
          </button> -->
        </div>
      </div>
      <!-- D: dimmed -->
      <div class="dimmed"></div>
    </template>
  </AbstractPop>
</template>
<script setup>
import { onMounted, defineEmits, reactive, inject, defineProps } from "vue";
import AbstractPop from "@/components/paintpro/common/AbstractPop.vue";
import { api } from "@/plugins/api";
import * as cmUtil from "@/utils/cmUtil";
import utils from "@/js/utils";

const url = inject("url_prefix");

const props = defineProps({
  product: {
    type: Object,
    require: true,
  },
});

const data = reactive({
  groupSn: "",
  groutList: [],
});

const emits = defineEmits(["close", "itemUpdate"]);

onMounted(() => {
  selectGroupList();
});

async function selectGroupList() {
  const res = await api.post(`${url}/myRoom/group/select`);
  if (res.resultCode === 200) {
    data.groutList = res.data;
  }
}

/*신규 그룹명 추가*/
async function btnSelectGroup() {
  if (utils.isBlank(data.groupSn)) {
    await cmUtil.alert("그룹을 선택하여 주십시오.");
    return;
  }

  const res = await api.post(`${url}/myRoom/item/insert`, {
    groupSn: data.groupSn,
    goodsSn: props.product.goodsSn,
  });
  cmUtil.loadingHide();
  if (res.resultCode === 200) {
    await cmUtil.alert("저장되었습니다.");
    data.groupSn = "";
    emits("close");
  }
}
</script>
